let RequestForm = {
    init: function(){
        var messagesLocalization;

        if($('html').attr('lang') === 'ru') {
            messagesLocalization = {
                required: "Это поле необходимо заполнить.",
                remote: "Пожалуйста, введите правильное значение.",
                email: "Пожалуйста, введите корректный адрес электронной почты.",
                url: "Пожалуйста, введите корректный URL.",
                date: "Пожалуйста, введите корректную дату.",
                dateISO: "Пожалуйста, введите корректную дату в формате ISO.",
                number: "Пожалуйста, введите число.",
                digits: "Пожалуйста, вводите только цифры.",
                creditcard: "Пожалуйста, введите правильный номер кредитной карты.",
                equalTo: "Пожалуйста, введите такое же значение ещё раз.",
                extension: "Пожалуйста, выберите файл с правильным расширением.",
                maxlength: $.validator.format( "Пожалуйста, введите не больше {0} символов." ),
                minlength: $.validator.format( "Пожалуйста, введите не меньше {0} символов." ),
                rangelength: $.validator.format( "Пожалуйста, введите значение длиной от {0} до {1} символов." ),
                range: $.validator.format( "Пожалуйста, введите число от {0} до {1}." ),
                max: $.validator.format( "Пожалуйста, введите число, меньшее или равное {0}." ),
                min: $.validator.format( "Пожалуйста, введите число, большее или равное {0}." )
            }
        }else{
            messagesLocalization = {
                required: "This field is required.",
                remote: "Please fix this field.",
                email: "Please enter a valid email address.",
                url: "Please enter a valid URL.",
                date: "Please enter a valid date.",
                dateISO: "Please enter a valid date (ISO).",
                number: "Please enter a valid number.",
                digits: "Please enter only digits.",
                equalTo: "Please enter the same value again.",
                maxlength: $.validator.format( "Please enter no more than {0} characters." ),
                minlength: $.validator.format( "Please enter at least {0} characters." ),
                rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
                range: $.validator.format( "Please enter a value between {0} and {1}." ),
                max: $.validator.format( "Please enter a value less than or equal to {0}." ),
                min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
                step: $.validator.format( "Please enter a multiple of {0}." )
            }
        }

        $.extend($.validator.messages, messagesLocalization);

        RequestForm.mask();
    },
    mask: function(){
        let maskPhone = $('[data-mask-phone]');

        if(maskPhone.length){
            maskPhone.mask('+7 000 000 00 00');
        }
    },
    validateForm: function($form){
        var lang = $('html').attr('lang');

        /* Правила валидации */
        // Кириллица без цифр
        $.validator.addMethod(
            'isCyrillic',
            function(value, element) {
                return value.match(/^([^a-zA-Z0-9]|[а-яА-ЯеЁ])+$/) || !value;
            },
            ((lang === 'ru') ? 'Можно вводить только кириллические символы' : 'Only cyrillic characters can be entered')
        );

        // latinic or number
        $.validator.addMethod(
            'isLatinicNumber',
            function(value, element) {
                return value.match(/^[a-zA-Z0-9]+$/) || !value;
            },
            ((lang === 'ru') ? 'Только латинские буквы и цифры' : 'Latin letters and numbers only')
        );

        // latinic
        $.validator.addMethod(
            'isLatinic',
            function(value, element) {
                return value.match(/^[a-zA-Z\s]+$/) || !value;
            },
            ((lang === 'ru') ? 'Только латинские буквы' : 'Latin letters only')
        );

        // запрет ввода других символов
        $('.isLatinic').bind('change keyup input click', function(e){
            if (this.value.match(/[^a-zA-Z\s]/g)) {
                this.value = this.value.replace(/[^a-zA-Z\s]/g, '');
            }
        });

        // only number
        $.validator.addMethod(
            'isNumber',
            function(value, element) {
                return value.match(/^[0-9]+$/) || !value;
            },
            ((lang === 'ru') ? 'Можно вводить только цифры' : 'Only numbers can be entered')
        );

        // запрет ввода других символов
        $('.isNumber').bind('change keyup input click', function(e){
            if (this.value.match(/[^0-9]/g)) {
                this.value = this.value.replace(/[^0-9]/g, '');
            }
        });

        // mobile phone
        $.validator.addMethod(
            'isPhone',
            function(value, element) {
                if(!!$(element).attr('required')){
                    // поле обязательно для заполнения
                    // ни одно из условий не должно выполняться
                    return !((value.length == 0) || (value.length < 15) || (value == '+7 ___-___-____') || value.indexOf('_') > 0);
                } else {
                    // поле необязательно для заполнения
                    // если часть поля заполнили
                    if ((value.length !== 0) || (value.length !== 15) || (value !== '+7 ___-___-____')){
                        // то валидируем
                        return !(value.indexOf('_') > 0 || value.length < 15);
                    } else {
                        // иначе пропускаем
                        return true;
                    }
                }
            },
            ((lang === 'ru') ? 'Пожалуйста, введите корректный номер телефона' : 'Please enter a valid phone number')
        );

        // дата окончания обучения
        $.validator.addMethod(
            'isShortDate',
            function(value, element) {
                if(!!$(element).attr('required')){
                    // поле обязательно для заполнения
                    // ни одно из условий не должно выполняться
                    return !((value.length == 0) || value.indexOf('г') >= 0 || value.indexOf('м') >= 0);
                } else {
                    // поле необязательно для заполнения
                    // если часть поля заполнили
                    if ((value.length !== 0) && ((value.indexOf('г') >= 0) || (value.indexOf('м') >= 0))){
                        // то валидируем
                        return false;
                    } else {
                        // иначе пропускаем
                        return true;
                    }
                }
            },
            ((lang === 'ru') ? 'Пожалуйста, введите месяц и год' : 'Please enter the month and year')
        );

        // Размер файла
        $.validator.addMethod("fileSize", function(value, element, param) {
            var result = true;

            if (!($('html').hasClass('bx-ie9'))) {
                if ($(element).length && element.files[0]) {
                    if (element.files[0].size > param) {
                        var maxSize = parseInt(parseInt($(element).attr('filesize'))/1024/1024);
                        $.validator.messages["fileSize"] = "Размер файла превышает максимальный " + maxSize + "Мб";
                        result = false;
                    }
                } else {
                    // если поле необязательно для заполнения
                    result = true;
                }
            }
            return result;
        }, ((lang === 'ru') ? 'Некорректный файл' : 'Invalid file'));


        // Тип файла
        $.validator.addMethod("fileType", function(value, element, param) {
            var result = true;

            if (!($('html').hasClass('bx-ie9'))) {
                if($(element).length && element.files[0]){
                    var nameFile = element.files[0].name,
                        arrNameFile = nameFile.split('.'),
                        typeFile = arrNameFile[arrNameFile.length-1],
                        captionFormat;

                    if (param.indexOf(typeFile) >= 0) {
                        $.validator.messages["fileType"] = "";
                        result = true;
                    } else {
                        if (param.indexOf('jpg') >= 0 && param.indexOf('doc') >= 0) {
                            captionFormat = 'jpg, png, rtf, pdf, doc или docx';
                        } else if(param.indexOf('jpg') >= 0){
                            captionFormat = 'jpg, bmp или png';
                        } else if(param.indexOf('doc') >= 0){
                            captionFormat = 'rtf, pdf, doc или docx';
                        }
                        $.validator.messages["fileType"] = "Выберите файл в формате " + captionFormat;
                        result = false;
                    }
                }
            }

            return result;
        }, ((lang === 'ru') ? 'Некорректный файл' : 'Invalid file'));

        // required for selectize create
        $.validator.addMethod("data-select-required", function(value, element, param) {
            if (element.nodeName.toLowerCase() === "select") {
                // Could be an array for select-multiple or a string, both are fine this way
                var val = $(element).val();
                return val && val.length > 0;
            }
        }, ((lang === 'ru') ? 'Это поле необходимо заполнить.' : 'This field is required.'));


        // Email
        $.validator.addMethod("customemail", function(value, element) {
            return value.match(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,15}(?:\.[a-z]{2})?)$/i) || !value;
        });
        $.extend($.validator.messages, {
            customemail: ((lang === 'ru') ? 'Пожалуйста, введите корректный адрес электронной почты.' : 'Please enter a valid email address.')
        });


        /* настройки валидации */
        var validateObj = {
            ignore: function (index, el) {
                var $el = $(el);

                if ($el.closest('.step_hidden').length || $el.closest('.not-visible').length) {
                    return true;
                }

                // Default behavior
                return $el.is('.ignore, *:not([name]), :hidden:not(input[type="file"], [class~=selectized]), :hidden > .selectized, .selectize-control .selectize-input input');
            },
            errorPlacement: function(error,element){
                var type = element.attr('type'),
                    is_select = $(element).closest('.select__wrap');

                if(type == 'checkbox') {
                    element.closest('.checkbox').addClass('checkbox_error');
                    element.closest('.form-group').append(error);
                } else if(type == 'radio') {
                    element.closest('.radio-group').addClass('radio-group_error').append(error);
                } else if(is_select) {
                    element.closest('.select__wrap').addClass('select__wrap_error');
                    element.closest('.form-group').append(error);
                } else if(type == 'file') {
                    element.closest('.file-upload').addClass('file-upload_error').append(error);
                } else {
                    error.insertAfter(element); // default error placement.
                    $(element).closest('.form-group').addClass('form-group_error');
                }
            },
            unhighlight: function(element, errorClass, validClass){
                var type = $(element).attr('type'),
                    is_select = $(element).closest('.select__wrap');

                if(type == 'checkbox') {
                    $(element).closest('.checkbox').removeClass('checkbox_error');
                } else if(type == 'radio') {
                    $(element).closest('.radio-group').removeClass('radio-group_error');
                } else if(is_select) {
                    $(element).closest('.select__wrap').removeClass('select__wrap_error');
                } else if(type == 'file') {
                    $(element).closest('.file-upload').removeClass('file-upload_error');
                }
                $(element).removeClass(errorClass).addClass(validClass);
                $(element).closest('.form-group').removeClass('form-group_error');

                //$(window).trigger('resize.px.parallax');
            },
            success: function(label){
                label.remove();
            }
        };

        $form.validate(validateObj);
    }
}

$(document).ready(function($) {
    RequestForm.init();
});

export default {
    validateForm: RequestForm.validateForm
};


// WEBPACK FOOTER //
// ./components/form.js